import { ModalProvider } from "@/providers/ModalProvider";
import { TooltipProvider } from "@/providers/TooltipProvider";
import { Auth0Provider } from "@auth0/auth0-react";

const AUTH0_DOMAIN = import.meta.env.VITE_AUTH0_DOMAIN || "";
const AUTH0_CLIENT_ID = import.meta.env.VITE_AUTH0_CLIENT_ID || "";

const isMobileToken = !!new URLSearchParams(window.location.search).get(
  "token"
);

export const Providers = ({ children }: { children: React.ReactNode }) => {
  const inner = (
    <TooltipProvider>
      <ModalProvider>{children}</ModalProvider>
    </TooltipProvider>
  );

  if (isMobileToken) {
    return inner;
  }

  return (
    <Auth0Provider
      domain={AUTH0_DOMAIN || ""}
      clientId={AUTH0_CLIENT_ID || ""}
      authorizationParams={{
        redirect_uri: window.location.origin,
      }}
    >
      {inner}
    </Auth0Provider>
  );
};
